@binding(0) @group(0) var data_sampler_0 : sampler;

@binding(1) @group(0) var data_texture_0 : texture_2d<f32>;

struct VertexOut_0
{
    @builtin(position) position_0 : vec4<f32>,
    @location(0) uv_0 : vec2<f32>,
};

@vertex
fn vertex(@builtin(vertex_index) vi_0 : u32) -> VertexOut_0
{
    var x_0 : f32 = f32(i32((vi_0 & (u32(1)))) * i32(4) - i32(1));
    var y_0 : f32 = f32(i32((vi_0 >> (u32(1)))) * i32(4) - i32(1));
    var output_0 : VertexOut_0;
    output_0.position_0 = vec4<f32>(x_0, y_0, 0.0f, 1.0f);
    output_0.uv_0 = vec2<f32>(x_0 * 0.5f + 0.5f, 0.5f - y_0 * 0.5f);
    return output_0;
}

struct pixelOutput_0
{
    @location(0) output_1 : vec4<f32>,
};

struct pixelInput_0
{
    @location(0) uv_1 : vec2<f32>,
};

@fragment
fn fragment( _S1 : pixelInput_0) -> pixelOutput_0
{
    var c_0 : f32 = (textureSample((data_texture_0), (data_sampler_0), (_S1.uv_1))).x;
    var fw_0 : f32 = 0.5f * (fwidth((c_0)));
    var _S2 : pixelOutput_0 = pixelOutput_0( vec4<f32>(0.0f, 0.0f, 0.0f, smoothstep(0.10000000149011612f - fw_0, 0.10000000149011612f + fw_0, c_0)) );
    return _S2;
}

